<template>
  <icon :style="{ color: 'hotpink',fontSize: '24px' }">
    <template #component>
      <svg t="1682216733364" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
           p-id="1493" width="1em" height="1em">
        <path
            d="M512 0C229.376 0 0 229.376 0 512s229.376 512 512 512 512-229.376 512-512S794.624 0 512 0z m42.496 728.576c0 9.216-5.632 17.92-13.824 22.016-3.072 1.536-6.656 2.048-10.24 2.048-5.632 0-10.752-2.048-15.36-5.632l-137.728-114.688H266.24c-6.144 0-12.288-2.56-16.896-7.168-4.608-4.608-7.168-10.752-7.168-16.896l0.512-192.512c0-6.144 2.56-12.288 7.168-16.896 4.608-4.608 10.752-7.168 16.896-7.168l110.08 0.512 138.24-115.2c7.168-6.144 16.896-7.168 25.6-3.072 8.704 4.096 13.824 12.288 13.824 22.016v432.64z m243.2-166.4c10.24 10.24 10.24 26.112 0 36.352-5.12 5.12-11.776 7.68-17.92 7.68-6.656 0-13.312-2.56-17.92-7.68l-50.176-50.176-50.176 50.176c-5.12 5.12-11.264 7.68-17.92 7.68-6.656 0-13.312-2.56-17.92-7.68-10.24-10.24-10.24-26.112 0-36.352l50.176-50.176-50.176-50.176c-10.24-9.728-10.24-26.112 0-36.352 9.728-10.24 26.112-10.24 36.352 0l50.176 50.176 50.176-50.176c10.24-10.24 26.112-10.24 36.352 0 10.24 9.728 10.24 26.112 0 36.352l-51.2 50.176 50.176 50.176z"
            p-id="1494" fill="#a31705"></path>
      </svg>
    </template>
  </icon>
</template>

<script>
// zhouhan@cibr.ac.cn 2023/4/23 10:25
import Icon from "@ant-design/icons-vue";

export default {
  name: "banSound",
  components: {Icon},

}
</script>

<style scoped>

</style>